/* eslint-disable no-extra-boolean-cast */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ImageOutlined, CloseFilled } from '@next-common/material-ui-icons';
import { LoadingScreen } from '../LoadingScreen';
import { DROPZONE_LABELS } from './constants';
import { ImageContainer, IconContainer, gridItem, StyledImage, useStyleDropzone } from './ImageUpload.style';
import { DropzoneAreaBase } from 'mui-file-dropzone';
import { colorPalette } from '../../colorPalette';
export const ImageUpload = ({ files, filesLimit, maxFileSize, acceptedFiles, onAdd, onDelete, onError, isUploading, title, body, dataQa, errors, dataQaError, dataQaTitle, }) => {
    const dropContainer = files.length > 0 || isUploading ? gridItem : {};
    const newLocal = 'error';
    const { classes } = useStyleDropzone();
    return (React.createElement(React.Fragment, null,
        !!title ? (React.createElement(Typography, { variant: "subtitle2", component: "h3", gutterBottom: true, "data-qa": dataQaTitle },
            title,
            " \u00A0",
            React.createElement(Box, { component: "span", sx: { color: colorPalette.gray700 } }, `${files.length} sur ${filesLimit}`))) : null,
        React.createElement(Grid, { container: true, spacing: 1 },
            files.map((image) => {
                var _a;
                return (React.createElement(ImageContainer, { key: image.uid, item: true, xs: true, style: gridItem },
                    React.createElement(IconContainer, { "aria-label": `Supprimer ${image.file.name}`, onClick: () => onDelete(image) },
                        React.createElement(CloseFilled, { style: {
                                backgroundColor: colorPalette.gray300,
                                borderRadius: '50%',
                                margin: '4px',
                            } })),
                    React.createElement(StyledImage, { src: (_a = image.data) === null || _a === void 0 ? void 0 : _a.toString(), alt: image.file.name, role: "presentation" })));
            }),
            isUploading && (React.createElement(Grid, { item: true, container: true, xs: true, style: gridItem },
                React.createElement(LoadingScreen, { spacing: 0, style: {
                        padding: 0,
                        justifyContent: 'center',
                        border: '1px solid #EBEBEB',
                        borderRadius: '4px',
                    }, size: 48 }))),
            React.createElement(Grid, { item: true, xs: true, style: dropContainer },
                React.createElement(DropzoneAreaBase, Object.assign({ classes: classes, 
                    /* @ts-expect-error Type V4 and V5 */
                    Icon: ImageOutlined, fileObjects: files, acceptedFiles: acceptedFiles, filesLimit: filesLimit, showPreviewsInDropzone: false, maxFileSize: maxFileSize, onAdd: (input) => onAdd(input), onDelete: (obj) => onDelete(obj), onAlert: (msg, variant) => {
                        if (variant === newLocal) {
                            return onError(msg);
                        }
                    }, inputProps: {
                        // @ts-ignore: to be selected in test files
                        'data-qa': dataQa,
                    }, showAlerts: ['info'] }, DROPZONE_LABELS)))),
        errors ? (React.createElement(Typography, { variant: "body1", component: "div", sx: {
                color: colorPalette.red500,
                paddingTop: '0.5rem',
                fontSize: '1.2rem',
                fontWeight: 400,
                lineHeight: 1.66,
            }, "data-qa": dataQaError }, errors)) : (React.createElement(React.Fragment, null, !!body ? (React.createElement(Typography, { variant: "body1", sx: {
                color: colorPalette.gray700,
                paddingTop: '0.5rem',
            } }, body)) : null))));
};
